import Image from "next/image"
import { Fragment, useRef } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { Swiper, SwiperSlide } from "swiper/react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

import "swiper/css"
import "swiper/css/pagination"
import "swiper/css/navigation"

import { Pagination, Navigation } from "swiper"

export default function Modal({ isOpenObj, setIsOpen, data, photoAlt }) {

  const cancelButtonRef = useRef(null)

  return (
    <Transition.Root show={isOpenObj.isOpen} as={Fragment}>
      <Dialog as="div" className="fixed z-10 inset-0 overflow-y-auto" initialFocus={cancelButtonRef} onClose={() => setIsOpen({ isOpen: false, picNum: 0 })}>
        <div className="flex items-center justify-center min-h-screen p-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="inline-block bg-midnight rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-full">
              <div className="bg-midnight p-2">
                <FontAwesomeIcon onClick={() => setIsOpen({ isOpen: false, picNum: 0 })} className='absolute right-4 top-4 text-slate-700 bg-white rounded-full w-[20px] !h-[20px] cursor-pointer z-10' icon={faTimes} />
                <Swiper
                  initialSlide={isOpenObj.picNum}
                  pagination={true}
                  navigation={true}
                  modules={[Pagination, Navigation]}
                  className="w-full h-[90vh]"
                  ref={cancelButtonRef}
                >
                  {data && data.map((fotoPath, idx) => {
                    return (
                      <SwiperSlide
                        key={idx}>
                        <div className="relative w-full h-full">
                          <Image
                            src={fotoPath}
                            alt={photoAlt}
                            layout="fill"
                            objectFit="contain"
                            quality={100}
                            priority
                          />
                        </div>
                      </SwiperSlide>
                    )
                  })}
                </Swiper>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  )
}